import React from 'react';
import { SourceType } from '../../../types';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
export var ONLINE_DATABASE_PUB_INFO = 'Online database publication info';
export var OnlineDatabaseContributorFunctions = [FunctionTypes.AUTHOR, FunctionTypes.EDITOR, FunctionTypes.COMPILER, FunctionTypes.TRANSLATOR];
export var CitingOptions = {
  Book: 'Book',
  ChapterInABook: 'Chapter in a book',
  EncyclopediaArticle: 'Encyclopedia article',
  JournalArticle: 'Journal article',
  MagazineArticle: 'Magazine article',
  NewspaperArticle: 'Newspaper article',
  Bible: 'Bible',
  BookChapterCollection: 'Book chapter in a collection',
  ConferenceProceedingsBook: 'Conference Proceedings (book)',
  ConferenceProceedingsPerdiodical: 'Conference Proceedings (periodical)',
  CongressionalPublication: 'Congressional publication',
  DictionaryEntry: 'Dictionary entry',
  Dissertation: 'Dissertation',
  DissertationAbstract: 'Dissertation abstract',
  EditorialInAMagazine: 'Editorial found in a magazine',
  EditorialInANewspaper: 'Editorial found in a newspaper',
  GovernmentPublication: 'Government publication',
  InterviewFromAMagazine: 'Interview from a magazine',
  InterviewFromANewspaper: 'Interview from a newspaper',
  JournalArticleCollection: 'Journal article in a collection',
  LectureSpeechAddress: 'Lecture / speech / address',
  Letter: 'Letter',
  MagazineArticleCollection: 'Magazine article in a collection',
  Manuscript: 'Manuscript',
  MapChart: 'Map / chart',
  MusicAudioRecording: 'Music / audio recording',
  Newsletter: 'Newsletter',
  NewspaperArticleCollection: 'Newspaper article in a collection',
  Painting: 'Painting',
  Photograph: 'Photograph',
  PrefaceIntroduction: 'Preface / introduction',
  Report: 'Report',
  ReviewFoundJournal: 'Review found in a journal',
  ReviewFoundMagazine: 'Review found in a magazine',
  ReviewFoundNewspaper: 'Review found in a newspaper',
  Thesis: 'Thesis',
  Other: 'Other',
  MostPopular: 'Most popular',
  FilmOnlineVideo: 'Film/Online video',
  OnlineDatabaseDefault: 'Article published by database'
};

/*
OtherSourceTypes variable below contains the sources that are not present with us, 
and hence we pass them a value manually
*/

export var OtherSourceType = {
  MostPopular: 'c',
  Other: 'f',
  BookChapterCollection: 'collection_pubnonperiodical_pubdatabase',
  ConferenceProceedingBook: 'conference_pubnonperiodical_pubdatabase',
  ConferenceProccedingPeriodical: 'conference_pubmagazine_pubdatabase',
  EditorialMagazine: 'editorial_pubmagazine_pubdatabase',
  EditorialNewspaper: 'editorial_pubnewspaper_pubdatabase',
  InterviewMagazine: 'interview_pubmagazine_pubdatabase',
  InterviewNewspaper: 'interview_pubnewspaper_pubdatabase',
  JournalCollection: 'collection_pubjournal_pubdatabase',
  MagazineCollection: 'collection_pubmagazine_pubdatabase',
  NewspaperCollection: 'collection_pubnewspaper_pubdatabase',
  ReviewJournal: 'review_pubjournal_pubdatabase',
  ReviewMagazine: 'review_pubmagazine_pubdatabase',
  ReviewNewspaper: 'review_pubnewspaper_pubdatabase'
};
export var citingOptions = [{
  uuid: SourceType.ONLINE_DATABASE,
  value: SourceType.ONLINE_DATABASE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.OnlineDatabaseDefault)
}, {
  uuid: OtherSourceType.MostPopular,
  value: OtherSourceType.MostPopular,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.MostPopular)
}, {
  uuid: SourceType.BOOK,
  value: SourceType.BOOK,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Book)
}, {
  uuid: SourceType.CHAPTER,
  value: SourceType.CHAPTER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.ChapterInABook)
}, {
  uuid: SourceType.ENCYCLOPEDIA,
  value: SourceType.ENCYCLOPEDIA,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.EncyclopediaArticle)
}, {
  uuid: SourceType.JOURNAL,
  value: SourceType.JOURNAL,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.JournalArticle)
}, {
  uuid: SourceType.MAGAZINE,
  value: SourceType.MAGAZINE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.MagazineArticle)
}, {
  uuid: SourceType.NEWSPAPER,
  value: SourceType.NEWSPAPER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.NewspaperArticle)
}, {
  uuid: OtherSourceType.Other,
  value: OtherSourceType.Other,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Other)
}, {
  uuid: SourceType.BIBLE,
  value: SourceType.BIBLE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Bible)
}, {
  uuid: OtherSourceType.BookChapterCollection,
  value: OtherSourceType.BookChapterCollection,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.BookChapterCollection)
}, {
  uuid: OtherSourceType.ConferenceProceedingBook,
  value: OtherSourceType.ConferenceProceedingBook,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.ConferenceProceedingsBook)
}, {
  uuid: OtherSourceType.ConferenceProccedingPeriodical,
  value: OtherSourceType.ConferenceProccedingPeriodical,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.ConferenceProceedingsPerdiodical)
}, {
  uuid: SourceType.CONGRESS,
  value: SourceType.CONGRESS,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.CongressionalPublication)
}, {
  uuid: SourceType.DICTIONARY,
  value: SourceType.DICTIONARY,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.DictionaryEntry)
}, {
  uuid: SourceType.DISSERTATION,
  value: SourceType.DISSERTATION,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Dissertation)
}, {
  uuid: SourceType.DISSERTATION_ABSTRACT,
  value: SourceType.DISSERTATION_ABSTRACT,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.DissertationAbstract)
}, {
  uuid: OtherSourceType.EditorialMagazine,
  value: OtherSourceType.EditorialMagazine,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.EditorialInAMagazine)
}, {
  uuid: OtherSourceType.EditorialNewspaper,
  value: OtherSourceType.EditorialNewspaper,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.EditorialInANewspaper)
}, {
  uuid: SourceType.FILM_ONLINE_VIDEO,
  value: SourceType.FILM_ONLINE_VIDEO,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.FilmOnlineVideo)
}, {
  uuid: SourceType.GOVERNMENT_PUBLICATION,
  value: SourceType.GOVERNMENT_PUBLICATION,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.GovernmentPublication)
}, {
  uuid: OtherSourceType.InterviewMagazine,
  value: OtherSourceType.InterviewMagazine,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.InterviewFromAMagazine)
}, {
  uuid: OtherSourceType.InterviewNewspaper,
  value: OtherSourceType.InterviewNewspaper,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.InterviewFromANewspaper)
}, {
  uuid: OtherSourceType.JournalCollection,
  value: OtherSourceType.JournalCollection,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.JournalArticleCollection)
}, {
  uuid: SourceType.LECTURE,
  value: SourceType.LECTURE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.LectureSpeechAddress)
}, {
  uuid: SourceType.LETTER,
  value: SourceType.LETTER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Letter)
}, {
  uuid: OtherSourceType.MagazineCollection,
  value: OtherSourceType.MagazineCollection,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.MagazineArticleCollection)
}, {
  uuid: SourceType.MANUSCRIPT,
  value: SourceType.MANUSCRIPT,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Manuscript)
}, {
  uuid: SourceType.MAP,
  value: SourceType.MAP,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.MapChart)
}, {
  uuid: SourceType.MUSICAL_RECORDING,
  value: SourceType.MUSICAL_RECORDING,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.MusicAudioRecording)
}, {
  uuid: SourceType.NEWSLETTER,
  value: SourceType.NEWSLETTER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Newsletter)
}, {
  uuid: OtherSourceType.NewspaperCollection,
  value: OtherSourceType.NewspaperCollection,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.NewspaperArticleCollection)
}, {
  uuid: SourceType.PAINTING,
  value: SourceType.PAINTING,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Painting)
}, {
  uuid: SourceType.PHOTO,
  value: SourceType.PHOTO,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Photograph)
}, {
  uuid: SourceType.INTRODUCTION,
  value: SourceType.INTRODUCTION,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.PrefaceIntroduction)
}, {
  uuid: SourceType.REPORT,
  value: SourceType.REPORT,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Report)
}, {
  uuid: OtherSourceType.ReviewJournal,
  value: OtherSourceType.ReviewJournal,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.ReviewFoundJournal)
}, {
  uuid: OtherSourceType.ReviewMagazine,
  value: OtherSourceType.ReviewMagazine,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.ReviewFoundMagazine)
}, {
  uuid: OtherSourceType.ReviewNewspaper,
  value: OtherSourceType.ReviewNewspaper,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.ReviewFoundNewspaper)
}, {
  uuid: SourceType.THESIS,
  value: SourceType.THESIS,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.Thesis)
}];